import { typographyStyles } from "@newsela/angelou";

const {
  fontSize,
  heading4Obj,
  heading5Obj,
  lineHeight,
  textLObj,
  textSObj,
  textXSObj,
} = typographyStyles;

export const bodyLineHeight = "184%"; // The same for body text at all text sizes

export const bodyFontSizeMapping = {
  small: textLObj.fontSize, // This is the only size the directly correlates to an angelou size.
  medium: "1.5rem",
  large: "1.875rem",
  extraLarge: "2.25rem",
};

export const headingFontSizeMapping = (isH2Heading = false) => ({
  small: isH2Heading ? fontSize.heading3 : fontSize.heading4,
  medium: "2rem",
  large: "2.375rem",
  extraLarge: "2.625rem",
});

export const headingLineHeightMapping = (isH2Heading = false) => ({
  small: isH2Heading ? lineHeight.heading3 : lineHeight.heading4,
  medium: "125%",
  large: "130%",
  extraLarge: "140%",
});

export const inlineCaptionFontSizeMapping = {
  small: textXSObj.fontSize,
  medium: textSObj.fontSize,
  large: heading5Obj.fontSize,
  extraLarge: textLObj.fontSize,
};

export const inlineCaptionLineHeightMapping = {
  small: "133%",
  medium: "171%",
  large: "171%",
  extraLarge: "178%",
};

export const powerWordButtonBottomPaddings = {
  small: "0px",
  medium: "2px",
  large: "2px",
  extraLarge: "2px",
};

export const powerWordButtonBorderBottomWidths = {
  small: "2px",
  medium: "2px",
  large: "3px",
  extraLarge: "3px",
};

export const powerWordButtonIconWidths = {
  small: "10px",
  medium: "10px",
  large: "15px",
  extraLarge: "15px",
};

// These values are used to calculate the power words bolt icon position
// Values are numbers instead of strings for easy calculation.
export const powerWordButtonIconHeights = {
  small: 11,
  medium: 11,
  large: 16.5,
  extraLarge: 16.5,
};

export const powerWordPopOutIconSizes = {
  small: "15px",
  medium: "24px",
  large: "24px",
  extraLarge: "24px",
};

export const powerWordPopOutHeaderFontSizes = {
  small: ".75rem",
  medium: "1rem",
  large: "1rem",
  extraLarge: "1rem",
};

export const powerWordPopOutTitleFontSizes = {
  small: "1.125rem",
  medium: "1.75rem",
  large: "1.75rem",
  extraLarge: "1.75rem",
};

export const powerWordPopOutBodyFontSizes = {
  small: ".875rem",
  medium: "1.5rem",
  large: "1.5rem",
  extraLarge: "1.5rem",
};

export const tooltipDialogOffset = {
  small: 15,
  medium: 20,
  large: 25,
  extraLarge: 30,
};

export const powerWordArticleBodyFontSizes = {
  small: "1.125rem",
  medium: "1.5rem",
  large: "1.875rem",
  extraLarge: "2.25rem",
};

export const checksForUnderstandingFontSizes = {
  small: heading4Obj.fontSize,
  medium: "1.5rem",
  large: "1.875rem",
  extraLarge: "2.25rem",
};

export const checksForUnderstandingEyebrowFontSizes = {
  small: textXSObj.fontSize,
  medium: "1.5rem",
  large: "1.5rem",
  extraLarge: "1.5rem",
};

export const checksForUnderstandingToggleFontSizes = {
  small: heading5Obj.fontSize,
  medium: "1.5rem",
  large: "1.5rem",
  extraLarge: "1.5rem",
};
